<template>
  <q-form ref="editForm">
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-card class="cardClassDetailForm" title="LBLBASEINFO">
          <template slot="card-button">
            <q-btn-group outline >
              <!--삭제-->  
              <c-btn 
                v-if="editable&&isOld" 
                label="LBLREMOVE" 
                icon="delete"
                @btnClicked="deleteTarget" />
              <!--저장-->
              <c-btn 
                v-if="editable" 
                :isSubmit="isSave"
                :url="saveUrl"
                :param="target"
                :mappingType="mappingType"
                label="LBLSAVE" 
                icon="save"
                @beforeAction="saveTarget"
                @btnCallback="saveTargetCallback" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-select
                :required="true"
                codeGroupCd="OBLI_TYPE_CD"
                :editable="editable && !isOld"
                type="edit"
                itemText="codeName"
                itemValue="code"
                name="obliTypeCd"
                label="평가구분"
                v-model="target.obliTypeCd"
                @datachange="targetDataChange"
              ></c-select>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-field
                required
                :editable="editable"
                :data="target"
                type="dept_user" 
                label="평가대상자" 
                name="evalTargetId" 
                v-model="target.evalTargetId" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-datepicker
                :required="true"
                :editable="editable"
                default="today"
                label="평가일"
                name="evalDt"
                v-model="target.evalDt"
              />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-field
                required
                :editable="editable"
                :data="target"
                type="dept_user" 
                label="평가자 담당" 
                name="evalManagerId" 
                v-model="target.evalManagerId" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-field
                required
                :editable="editable"
                :data="target"
                type="dept_user" 
                label="평가자 팀장" 
                name="evalLeaderId" 
                v-model="target.evalLeaderId" />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
              <c-select
                :editable="false"
                codeGroupCd="OBLI_EVAL_GRADE_CD"
                type="custom"
                typetext="평가 전"
                itemText="codeName"
                itemValue="code"
                name="evalGrade"
                label="평가등급"
                v-model="target.evalGrade"
              ></c-select>
            </div>
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="table"
          title="의무사항 이행평가"
          :columns="grid.columns"
          :data="target.results"
          :gridHeight="gridHeight"
          :editable="editable"
          :usePaging="false"
          :isExcelDown="true"
          :filtering="false"
          :isFullScreen="true"
          :columnSetting="false"
          @table-data-change="tableDataChange"
        >
          <template v-slot:customBottomRow>
            <q-tr 
              v-if="target.results && target.results.length > 0" 
              no-hover
              class="table-bottom-fixed">
              <q-td
                class="text-center th-td-style th-style"
                :rowspan="1" :colspan="1">
              </q-td>
              <q-td
                class="text-center th-td-style th-style"
                :rowspan="1" :colspan="1">
              </q-td>
              <q-td
                class="text-center th-td-style th-style"
                :rowspan="1" :colspan="2">합계
              </q-td>
              <q-td
                class="text-right th-td-style th-style"
                :rowspan="1" :colspan="1">
                <span>
                  {{ target.evalPoint | toThousandFilter }}
                </span>
              </q-td>
            </q-tr>
          </template>
        </c-table>
      </div>
    </div>
  </q-form>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';

export default {
  name: 'safety-healthy-target-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiSafetyHealthObliResultId: '',
      }),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentHeight: null,
  },
  data() {
    return {
      target: {
        saiSafetyHealthObliResultId: '',  // 평가결과 일련번호
        obliTypeCd: null,  // 평가구분
        evalManagerId: '',  // 평가자 담당
        evalLeaderId: '',  // 평가자 팀장
        evalTargetId: '',  // 평가대상자
        evalDt: '',  // 평가일
        evalPoint: 0,  // 평가점수
        evalGrade: null,  // 평가등급
        results: [],
      },
      grid: {
        columns: [
          {
            name: 'sortOrder',
            field: 'sortOrder',
            label: 'No.',
            align: 'center',
            style: 'width: 70px',
            sortable: false,
          },
          {
            name: 'obliItemEvalCriteria',
            field: 'obliItemEvalCriteria',
            label: '평가지표',
            align: 'left',
            style: 'width: 400px',
            type: 'html',
            sortable: false,
          },
          {
            name: 'obliItemConfirmTarget',
            field: 'obliItemConfirmTarget',
            label: '확인대상(문서 및 현장)',
            align: 'left',
            style: 'width: 400px',
            type: 'html',
            sortable: false,
          },
          {
            name: 'distribution',
            field: 'distribution',
            label: '배점',
            align: 'center',
            style: 'width: 80px',
            sortable: false,
          },
          {
            name: 'score',
            field: 'score',
            label: '점수',
            type: 'number',
            style: 'width: 100px',
            sortable: false,
          },
        ],
        data: [],
      },
      editable: false,
      isSave: false,
      detailUrl: '',
      targetListUrl: '',
      saveUrl: '',
      deleteUrl: '',
      mappingType: 'PUT',
      obliEvalGrade: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    gridHeight() {
      return String(this.contentHeight - 180) + 'px';
    },
    isOld() {
      return Boolean(this.popupParam.saiSafetyHealthObliResultId)
    },
  },
  watch: {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      this.detailUrl = selectConfig.sai.obli.result.get.url;
      this.saveUrl = transactionConfig.sai.obli.result.insert.url;
      this.deleteUrl = transactionConfig.sai.obli.result.delete.url;
      this.targetListUrl = selectConfig.sai.obli.item.list.url;
      this.$comm.getComboItems('OBLI_EVAL_GRADE_CD').then(_result => {
        this.obliEvalGrade = _result
      });
      this.getDetail();
    },
    getDetail() {
      if (this.isOld) {
        this.$http.url = this.detailUrl;
        this.$http.param = {saiSafetyHealthObliResultId: this.popupParam.saiSafetyHealthObliResultId};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          // 상세팝업 최초작성/최근수정 정보 노출
          this.$emit('setRegInfo', _result.data)
          this.$_.extend(this.target, _result.data)
        },);
      }
    },
    targetDataChange() {
      this.$http.url = this.targetListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        obliTypeCd: this.target.obliTypeCd,
        useFlag: 'Y',
      };
      this.$http.request((_result) => {
        let results = [];
        this.$_.forEach(_result.data, _item => {
          results.push({  
            saiSafetyHealthObliResultId: this.popupParam.saiSafetyHealthObliResultId,  // 안전보건의무사항 이행평가 결과 일련번호
            saiSafetyHealthObliItemResultId: uid(),  // 항목 일련번호
            obliTypeCd: _item.obliTypeCd,  // 구분
            obliItemEvalCriteria: _item.obliItemEvalCriteria,  // 평가지표
            obliItemConfirmTarget: _item.obliItemConfirmTarget,  // 확인대상
            distribution: _item.distribution,  // 배점
            deductedFlag: _item.deductedFlag,  // 가점여부
            sortOrder: _item.sortOrder,  // 순번
            score: '',  // 점수
            editFlag: 'C'
          }) 
        })
        this.target.results = results;
      },);
    },
    tableDataChange(props, col) {
      if (col.name === 'score') {
        if (Number(props.row['distribution']) < 0) {
          if ((Number(props.row['score']) * -1) > (Number(props.row['distribution']) * -1)) {
            this.$set(props.row, 'score', 0)
            window.getApp.$emit('ALERT', {
              title: 'LBLGUIDE', // 안내
              message: '점수가 배점보다 클 수 없습니다.', // 선택된 항목이 없습니다.
              type: 'success', // success / info / warning / error
            });
          } else {
            this.$set(props.row, 'score', Number(props.row['score']))
          }
        } else {
          if (Number(props.row['score']) > Number(props.row['distribution'])) {
            this.$set(props.row, 'score', 0)
            window.getApp.$emit('ALERT', {
              title: 'LBLGUIDE', // 안내
              message: '점수가 배점보다 클 수 없습니다.', // 선택된 항목이 없습니다.
              type: 'success', // success / info / warning / error
            });
          } else {
            this.$set(props.row, 'score', Number(props.row['score']))
          }
        }

        let _sumpoint = 0
        this.$_.forEach(this.target.results, item => {
          _sumpoint += Number(item.score)
        });
        this.$set(this.target, 'evalPoint', Number(_sumpoint))

        this.$_.forEach(this.obliEvalGrade, _item => {
          if (Number(_sumpoint) >= Number(_item.attrVal1) && Number(_sumpoint) <= Number(_item.attrVal2)) {
            this.$set(this.target, 'evalGrade', _item.code);
            return;
          }
        });
      }
    },
    saveTarget() {
      if (this.isOld) {
        this.mappingType = 'PUT'
        this.saveUrl = transactionConfig.sai.obli.result.update.url;
      } else {
        this.mappingType = 'POST'
        this.saveUrl = transactionConfig.sai.obli.result.insert.url;
      }
      
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',  // 확인
            message: 'MSGSAVE', // 저장하시겠습니까?   // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.target.regUserId = this.$store.getters.user.userId
              this.target.chgUserId = this.$store.getters.user.userId
      
              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveTargetCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.saiSafetyHealthObliResultId = result.data
      this.getDetail();
    },
    deleteTarget() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',  // 확인
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.saiSafetyHealthObliResultId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup')
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
  }
};
</script>